import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { CountriesActions } from "./countries.actions";

// **************************************************************************
// COUNTRIES REDUCER
// **************************************************************************

const load = on(CountriesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        country: {
            ...state.data.country,
            countryLoading: true,
        },
    },
}));

const loadSuccess = on(CountriesActions.loadSuccess, (state: ApplicationStore, { country }) => ({
    ...state,
    data: {
        ...state.data,
        country: {
            ...state.data.country,
            currentCountry: country,
            countryLoading: false,
        },
    },
}));

const loadFailure = on(CountriesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        country: {
            ...state.data.country,
            countryLoading: false,
        },
    },
}));

export const countriesReducer = [load, loadSuccess, loadFailure];
